import { gql } from '@apollo/client'

import { SIMPLE_ENTITY_FRAGMENT } from '../../../common/graphql/fragments'

const ROLES_QUERY = gql`
  query roles {
    roles {
      ...SimpleEntityFragment
    }
  }
  ${SIMPLE_ENTITY_FRAGMENT}
`

export default ROLES_QUERY
